import { getActiveLanguage } from '../i18n/languages';

/**
 * Options shared by every request. Kept in one place so a header only has to be added once.
 * @returns {object}
 */
function baseOptions() {
    return {
        mode: 'cors',
        cache: 'no-cache',
        redirect: 'follow',
        credentials: 'include',
        referrer: "no-referrer"
    };
}

/**
 * Headers shared by every request.
 *
 * Multipart requests must NOT get a Content-Type: the browser has to set it itself so that it can
 * include the multipart boundary. Only json() adds Content-Type.
 * @returns {object}
 */
function baseHeaders() {
    return {
        'Accept-Language': getActiveLanguage()
    };
}

function jsonHeaders() {
    return {
        ...baseHeaders(),
        'Content-Type': 'application/json; charset=utf-8'
    };
}

export default class external {
    constructor(baseUrl, timeout = 5000, ) {
        this.baseUrl = baseUrl;
        this.timeout = timeout;
        this.Request = Request;

        this.get = {
            'json': this._get_json.bind(this)
        };

        this.post = {
            'json': this._post_json.bind(this)
        };

        this.post_multipart = {
            'json': this._post_multipart_json.bind(this)
        };

        this.put = {
            'json': this._put_json.bind(this)
        };

        this.put_multipart = {
            'json': this._put_multipart_json.bind(this)
        };

        this.delete = {
            'json': this._delete_json.bind(this)
        }
    }

    static async static_get(path) {
        return await fetch(path, {
            ...baseOptions(),
            headers: jsonHeaders()
        })
        .then((response) => response.json());
    }

    async _get_json(path, token = null) {
        return await fetch(this.baseUrl + path, {
                ...baseOptions(),
                headers: jsonHeaders()
            })
            .then((response) => response.json());
    }

    async _post_json(path, content, token = null) {
        return await fetch(this.baseUrl + path, {
                ...baseOptions(),
                method: 'POST',
                body: JSON.stringify(content),
                headers: jsonHeaders()
            })
            .then((response) => response.json());
    }

    async _post_multipart_json(path, content, token = null) {
        return await fetch(this.baseUrl + path, {
                ...baseOptions(),
                method: 'POST',
                body: content,
                headers: baseHeaders()
            })
            .then((response) => response.json());
    }

    async _put_json(path, content, token = null) {
        return await fetch(this.baseUrl + path, {
                ...baseOptions(),
                method: 'PUT',
                body: JSON.stringify(content),
                headers: jsonHeaders()
            })
            .then((response) => response.json());
    }

    async _put_multipart_json(path, content, token = null) {
        return await fetch(this.baseUrl + path, {
                ...baseOptions(),
                method: 'PUT',
                body: content,
                headers: baseHeaders()
            })
            .then((response) => response.json());
    }

    async _delete_json(path, content = null, token = null) {
        return await fetch(this.baseUrl + path, {
                ...baseOptions(),
                method: 'DELETE',
                body: JSON.stringify(content),
                headers: jsonHeaders()
            })
            .then((response) => response.json());
    }
}
